import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import App from './App.vue';
import router from './router';
import { overwatch } from './plugins/overwatch';

import 'primeicons/primeicons.css';
import './assets/main.css';
import './assets/transitions.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);

// Overwatch self-monitoring — secrets come from Infisical via VITE_OVERWATCH_* vars
app.use(overwatch, {
  apiUrl: import.meta.env.VITE_OVERWATCH_API_URL || '/api',
  apiKey: import.meta.env.VITE_OVERWATCH_API_KEY || '',
  environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
  enabled: !!import.meta.env.VITE_OVERWATCH_API_KEY,
});

app.mount('#app');
